// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__G2FKL","info":"Panel_info__y7I66","btns":"Panel_btns__uE9Hk","button":"Panel_button__Wq1Dv"};